module.exports = "/deep/ .mat-input-wrapper {\n  margin: 0 !important;\n}\n"